/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, amount: NonNullable<unknown> }} Equivalence_CarInputs */

const en_us2_equivalence_car = /** @type {(inputs: Equivalence_CarInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`the weight of a car`);
	return /** @type {LocalizedString} */ (`the weight of ${i?.amount} cars`)
	
};

const pt_br2_equivalence_car = /** @type {(inputs: Equivalence_CarInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`o peso de um carro`);
	return /** @type {LocalizedString} */ (`o peso de ${i?.amount} carros`)
	
};

const es_419_equivalence_car = /** @type {(inputs: Equivalence_CarInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`el peso de un auto`);
	return /** @type {LocalizedString} */ (`el peso de ${i?.amount} autos`)
	
};

const pt_pt2_equivalence_car = /** @type {(inputs: Equivalence_CarInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`o peso de um carro`);
	return /** @type {LocalizedString} */ (`o peso de ${i?.amount} carros`)
	
};

const fr_fr2_equivalence_car = /** @type {(inputs: Equivalence_CarInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`le poids d'une voiture`);
	return /** @type {LocalizedString} */ (`le poids de ${i?.amount} voitures`)
	
};

const de_de2_equivalence_car = /** @type {(inputs: Equivalence_CarInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`das Gewicht eines Autos`);
	return /** @type {LocalizedString} */ (`das Gewicht von ${i?.amount} Autos`)
	
};

const it_it2_equivalence_car = /** @type {(inputs: Equivalence_CarInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`il peso di un'auto`);
	return /** @type {LocalizedString} */ (`il peso di ${i?.amount} auto`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "the weight of a car" |
* | * | "the weight of {amount} cars" |
*
* @param {Equivalence_CarInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const equivalence_car = /** @type {((inputs: Equivalence_CarInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equivalence_CarInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_equivalence_car(inputs)
	if (locale === "es-419") return es_419_equivalence_car(inputs)
	if (locale === "pt-PT") return pt_pt2_equivalence_car(inputs)
	if (locale === "fr-FR") return fr_fr2_equivalence_car(inputs)
	if (locale === "de-DE") return de_de2_equivalence_car(inputs)
	if (locale === "it-IT") return it_it2_equivalence_car(inputs)
	return en_us2_equivalence_car(inputs)
});
export { equivalence_car as "equivalence.car" }